import React from 'react'

interface NotificationSettingsProps {
  [key: string]: any
}

export const NotificationSettings: React.FC<NotificationSettingsProps> = (props) => {
  return (
    <div className="p-4 bg-gray-800 rounded-lg">
      <p className="text-gray-400">NotificationSettings Component - Coming Soon</p>
    </div>
  )
}
